// src/index.js

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "./react-auth0-spa";
import config from "./auth_config.json";
import history from "./utils/history";

interface Auth0AppState {
  targetUrl?: string;
  search: string;
}

// A function that routes the user to the right place
// after login
const onRedirectCallback = (appState?: Auth0AppState) => {
  //alert("redirecting to " + appState.targetUrl)
  console.log(appState);
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl + appState.search
      : window.location.pathname
  );
};

ReactDOM.render(
  <Auth0Provider
    domain={config.domain}
    client_id={config.clientId}
    redirect_uri={window.location.origin}
    audience={config.audience}
    onRedirectCallback={onRedirectCallback}
  >
    <App />
  </Auth0Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
